<template>
  <div class="risk-assessment-tab">
    <div class="tab-header">
      <h2>Risk Assessment</h2>
      <p class="tab-description">
        Comprehensive risk identification and evaluation
      </p>
    </div>

    <form @submit.prevent="validateAndSubmit" class="project-form">
      
      <!-- Section A: Financing Risk -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section A: Financing Risk</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Have similar PPP projects achieved financial close in the country or region?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q1_comments">Comments</label>
            <textarea 
              id="sectionA_q1_comments"
              v-model="formData.sectionA_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Are there financiers who will express or have expressed interest in the PPP?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q2_comments">Comments</label>
            <textarea 
              id="sectionA_q2_comments"
              v-model="formData.sectionA_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Will financial close be a condition precedent to the effectiveness of the PPP agreement?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q3_comments">Comments</label>
            <textarea 
              id="sectionA_q3_comments"
              v-model="formData.sectionA_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Can it be reasonably expected that financial close will not be delayed to affect materially the conditions of effectiveness of the PPP agreement?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionA_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionA_q4_comments">Comments</label>
            <textarea 
              id="sectionA_q4_comments"
              v-model="formData.sectionA_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section B: Design and Construction Risk -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section B: Design and Construction Risk</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Is the project likely to be based on technology that has been proven commercially in similar environments previously?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q1_comments">Comments</label>
            <textarea 
              id="sectionB_q1_comments"
              v-model="formData.sectionB_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Is the proposed site accessible with any potential challenges during construction being manageable?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q2_comments">Comments</label>
            <textarea 
              id="sectionB_q2_comments"
              v-model="formData.sectionB_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Will design and construction skills be available for this project and can be sourced either locally, regionally or globally?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q3_comments">Comments</label>
            <textarea 
              id="sectionB_q3_comments"
              v-model="formData.sectionB_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Does the project scope allow the private sector to manage efficiently the design, construction, and commissioning risks?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q4_comments">Comments</label>
            <textarea 
              id="sectionB_q4_comments"
              v-model="formData.sectionB_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">5. Will there be a strong system to manage contractor/subcontractor performance and construction-related challenges?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q5" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q5_comments">Comments</label>
            <textarea 
              id="sectionB_q5_comments"
              v-model="formData.sectionB_q5_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">6. Will there be independent reviews of designs, monitoring of construction progress and oversight during testing and commissioning phases?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionB_q6" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionB_q6_comments">Comments</label>
            <textarea 
              id="sectionB_q6_comments"
              v-model="formData.sectionB_q6_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section C: Operations and Maintenance Risk -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section C: Operations and Maintenance Risk</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Does the project scope clearly include a well-defined, measurable, and verifiable O&M component?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q1_comments">Comments</label>
            <textarea 
              id="sectionC_q1_comments"
              v-model="formData.sectionC_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Will there be a strong system of safeguards, incentives and liabilities to manage contractor/sub-contractor/ equipment supplier performance during O&M?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q2_comments">Comments</label>
            <textarea 
              id="sectionC_q2_comments"
              v-model="formData.sectionC_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Will O&M skills be available for this project and can be sourced either locally, regionally, or globally?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionC_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionC_q3_comments">Comments</label>
            <textarea 
              id="sectionC_q3_comments"
              v-model="formData.sectionC_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section D: Market Risk and Demand Risk -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section D: Market Risk and Demand Risk</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Will the PPP have a ready baseline of demand or offtake that has been well established through historical data, firm off-take commitments, or exclusivity of service area?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q1_comments">Comments</label>
            <textarea 
              id="sectionD_q1_comments"
              v-model="formData.sectionD_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Are there precedents of similar projects in the country or region, where the actual usage or offtake from the project facility in the initial years has been atleast 85% of the originally projected usage or off-take?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q2_comments">Comments</label>
            <textarea 
              id="sectionD_q2_comments"
              v-model="formData.sectionD_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Are there competing projects in the defined market that could impact the ramping up of demand for this PPP project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q3_comments">Comments</label>
            <textarea 
              id="sectionD_q3_comments"
              v-model="formData.sectionD_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Is there an indication that user charges will be affordable to users? Such as through an assessment of the ability and willingness to pay of the users or benchmarking with similar projects.</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q4_comments">Comments</label>
            <textarea 
              id="sectionD_q4_comments"
              v-model="formData.sectionD_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">5. In case of delays in ramping up of demand, will the private sector have some flexibility in repricing tariffs to manage and off-set demand shortfalls in any given year, or would the government provide some level of cash deficiency support or assurances?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q5" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q5" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q5" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q5" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q5" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q5_comments">Comments</label>
            <textarea 
              id="sectionD_q5_comments"
              v-model="formData.sectionD_q5_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">6. Is there a transparent and well-defined process for setting user charges and managing their increase?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q6" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q6" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q6" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q6" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionD_q6" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionD_q6_comments">Comments</label>
            <textarea 
              id="sectionD_q6_comments"
              v-model="formData.sectionD_q6_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Section E: Environmental and Social Risk -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section E: Environmental and Social Risk</h3>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1. Is there a credible environmental and social impact analysis of the PPP?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q1_comments">Comments</label>
            <textarea 
              id="sectionE_q1_comments"
              v-model="formData.sectionE_q1_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2. Are the costs of mitigating the environmental and social impacts of the project considered in the PPP?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q2_comments">Comments</label>
            <textarea 
              id="sectionE_q2_comments"
              v-model="formData.sectionE_q2_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3. Can the private sector manage the environmental and social impact mitigation measures envisaged in its scope?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q3_comments">Comments</label>
            <textarea 
              id="sectionE_q3_comments"
              v-model="formData.sectionE_q3_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4. Will the private sector take on environmental and social risks applicable after the contract signing date and not prior period liabilities?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q4_comments">Comments</label>
            <textarea 
              id="sectionE_q4_comments"
              v-model="formData.sectionE_q4_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">5. Will there be contractual measures to ensure that the project financials are reset in the event of delays in executing mitigation for reasons beyond the control of the project company?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q5" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q5" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q5" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q5" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.sectionE_q5" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="sectionE_q5_comments">Comments</label>
            <textarea 
              id="sectionE_q5_comments"
              v-model="formData.sectionE_q5_comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

    </form>
  </div>
</template>

<script>
export default {
  name: 'RiskAssessmentTab',
  props: {
    projectData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        // Section A: Financing Risk
        sectionA_q1: '',
        sectionA_q1_comments: '',
        sectionA_q2: '',
        sectionA_q2_comments: '',
        sectionA_q3: '',
        sectionA_q3_comments: '',
        sectionA_q4: '',
        sectionA_q4_comments: '',
        
        // Section B: Design and Construction Risk
        sectionB_q1: '',
        sectionB_q1_comments: '',
        sectionB_q2: '',
        sectionB_q2_comments: '',
        sectionB_q3: '',
        sectionB_q3_comments: '',
        sectionB_q4: '',
        sectionB_q4_comments: '',
        sectionB_q5: '',
        sectionB_q5_comments: '',
        sectionB_q6: '',
        sectionB_q6_comments: '',
        
        // Section C: Operations and Maintenance Risk
        sectionC_q1: '',
        sectionC_q1_comments: '',
        sectionC_q2: '',
        sectionC_q2_comments: '',
        sectionC_q3: '',
        sectionC_q3_comments: '',
        
        // Section D: Market Risk and Demand Risk
        sectionD_q1: '',
        sectionD_q1_comments: '',
        sectionD_q2: '',
        sectionD_q2_comments: '',
        sectionD_q3: '',
        sectionD_q3_comments: '',
        sectionD_q4: '',
        sectionD_q4_comments: '',
        sectionD_q5: '',
        sectionD_q5_comments: '',
        sectionD_q6: '',
        sectionD_q6_comments: '',
        
        // Section E: Environmental and Social Risk
        sectionE_q1: '',
        sectionE_q1_comments: '',
        sectionE_q2: '',
        sectionE_q2_comments: '',
        sectionE_q3: '',
        sectionE_q3_comments: '',
        sectionE_q4: '',
        sectionE_q4_comments: '',
        sectionE_q5: '',
        sectionE_q5_comments: ''
      },
      errors: {},
      showValidation: false
    }
  },
  computed: {
    isValid() {
      return this.validateForm().isValid
    }
  },
  watch: {
    projectData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.formData = { ...this.formData, ...newData }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateData() {
      this.$emit('update', this.formData)
      this.validateForm()
    },
    validateForm() {
      this.errors = {}
      let isValid = true

      this.showValidation = true
      this.$emit('validate', isValid)
      
      return { isValid, errors: this.errors }
    },
    validateAndSubmit() {
      this.validateForm()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.validateForm()
    })
  }
}
</script>

<style scoped>
.risk-assessment-tab {
  max-width: 1000px;
  margin: 0 auto;
}

.tab-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e9ecef;
}

.tab-header h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.tab-description {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.form-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border-left: 4px solid #00338d;
}

.section-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.section-header h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: block;
}

.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e0e6ed;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: white;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.form-group textarea:focus {
  outline: none;
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
}

.checkbox-label {
  display: block !important;
}

.checkbox-text {
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  display: block;
}

.radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
  align-items: stretch;
}

.radio-option {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  padding: 0.75rem 1rem;
  min-height: 40px;
  position: relative;
  transition: all 0.2s ease;
  border-radius: 8px;
  border: 2px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  text-align: center;
}

.radio-option input[type="radio"] {
  display: none;
}

.radio-option:has(input[type="radio"]:checked) {
  background: #00338d;
  border-color: #00338d;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(0, 51, 141, 0.2);
}

.radio-option:hover {
  background-color: #e8f0fe;
  border-color: #00338d;
  color: #00338d;
}

.radio-option:hover:has(input[type="radio"]:checked) {
  background: #002966;
  border-color: #002966;
  color: white;
}

.radio-option:has(input[type="radio"]:focus) {
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
  outline: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .radio-group {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .radio-option {
    padding: 0.75rem 0.75rem;
    min-height: 44px;
    font-size: 0.95rem;
  }
  
  .form-section {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .radio-group {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .radio-option {
    padding: 1rem 0.75rem;
    min-height: 48px;
    font-size: 0.9rem;
  }
}
</style>